import { render, staticRenderFns } from "./AnnotationTitle.vue?vue&type=template&id=f9c5f5f8"
import script from "./AnnotationTitle.vue?vue&type=script&lang=js"
export * from "./AnnotationTitle.vue?vue&type=script&lang=js"
import style0 from "./AnnotationTitle.vue?vue&type=style&index=0&id=f9c5f5f8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports